export default {
  CREATE_VIEWS_REQUEST: '@createViews/CREATE_VIEWS_REQUEST',
  CREATE_VIEWS_SUCCESS: '@createViews/CREATE_VIEWS_SUCCESS',
  CREATE_VIEWS_FAILURE: '@createViews/CREATE_VIEWS_FAILURE',
};
